import { render, staticRenderFns } from "./copays-select.vue?vue&type=template&id=1ab1dfa0&"
import script from "./copays-select.vue?vue&type=script&lang=js&"
export * from "./copays-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports